import { GrDocumentPdf } from 'react-icons/gr'
import "./_cardDownloadArchive.scss";
import { useContext } from 'react';
import { AuthContext } from '../../contexts/auth';
import axios from 'axios';

function CardDownloadArchive(props){
    const { updateToken } = useContext(AuthContext);

    const sendDownloadPost = async (link) => {
        try {
            updateToken();
        
            const url = `${process.env.REACT_APP_API_URL}/downloads`;
        
            await axios.post(
                url,
                { 
                  'download_id': props.id,
                },
                {
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                  },
                }
            );
        
            window.open(link, "_blank");
        } catch (error) {}
    }; 

    return(
        <div className="box-card-archive">
            <GrDocumentPdf/>

            <p>{props.title}</p>

            <a
                onClick={(e) => {
                    e.preventDefault(); 
                    sendDownloadPost(props.hrefArchive);
                }}
                href={props.hrefArchive}
                target="_blank"
                rel="noopener noreferrer"
                download="download"
                type="application/pdf"
                className="btn-archive"
            >
                Download
            </a>

        </div>
    )
}

export default CardDownloadArchive;